import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import InfiniteScroll from 'react-infinite-scroller';

import Layout from "../../component/Layout/Layout";
import Card from "../../component/Layout/theme/card";
import LogOut from "../../component/dashboard/user/logout/logout";
import PageChange from "../../component/pageChange";
import CustomModal from "../../component/Modal/custom";
import { Input } from "../../component/form/input";
import './index.css';
import toast from "react-hot-toast";



function IndexPage() {
    var { t } = useTranslation()
    const { login, user, token } = useSelector((item) => item.user)
    const [isDataLoad, setIsDataLoad] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(25);
    const [data, setData] = useState([]);
    const [typeAR, setTypeAR] = useState("");
    const [name, setName] = useState("");



    useEffect(() => {
        document.title = "پروژه های من"
        if (!login) {
            window.location.href = '/auth'
        } else {
            getAllAugmentedReality(page)
        }
    }, [])

    async function getAllAugmentedReality(paging) {
        await fetch(`${process.env.REACT_APP_SERVER}/api/nft/all/${limit}/${paging}`, {
            method: "GET",
            headers: {
                Authorization: "ArNew " + token,
            },
        }).then((res) => {
            res
                .json()
                .then((result) => {
                    if (!result.data) {
                        LogOut();
                        toast.error("شما دسترسی ندارید");
                        window.location.href = '/login';
                    }
                    if (result.status === "success") {
                        setIsDataLoad(true)
                        if (result.pages < paging) {
                            setHasMore(false)
                        } else {
                            setData(data => [...data, ...result.data]);
                            setPage(paging)
                        }
                    } else {
                        toast.error(result.msg);
                        LogOut();
                        window.location.href = '/login';
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        });
    }

    const formatPrice = (value) => {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const htmlPopup = () => {
        return (
            <div className="max-w-[400px] flex flex-col gap-2">
                <div className="relative mt-2 ">
                    <Input
                        placeholder={"نام پروژه"}
                        type="text"
                        id={"name"}
                        name={"name"}
                        autoComplete={"off"}
                        requiredir={true}
                        onChange={(e) => {
                            setName(e.target.value);
                            handleButtonDisableContinue()
                        }}
                    />
                </div>


                <button className={`border border-1 h-auto rounded-xl ${typeAR == "MARKER" ? "border-gray-400" : "border-gray-300"}`} onClick={() => setTypeAR("MARKER")}>
                    <div className="grid grid-cols-7 m-4 gap-2">
                        <div className="flex flex-col col-span-5 gap-1 text-start">
                            <p className="font-bold text-base text-gray-900">مبتنی بر نشانگر</p>
                            <p className="font-normal text-sm text-gray-700">محتوای دو بعدی و سه بعدی خود را به تصاویر متصل کنید و واقعیت افزوده را با تلفن هوشمند خود تجربه کنید.</p>
                            {user && user.payments && user.payments.type == "DAILY" && (
                                <p className="font-normal text-sm text-gray-500">{`پرداخت روزانه ${formatPrice("2000")} تومان`}</p>
                            )}

                        </div>
                        <div className="col-span-2 m-auto">
                            <img className="free-image col-span-1" width="85px" src={process.env.REACT_APP_ADDRESS + "/icons/ic-marker-based-ar.svg"} alt="marker-based-ar" />
                        </div>
                    </div>
                </button>
                <button className={`border border-1 h-auto rounded-xl ${typeAR == "MARKERLESS" ? "border-gray-400" : "border-gray-300"}`} onClick={() => setTypeAR("MARKERLESS")}>
                    <div className="grid grid-cols-7 m-4 gap-2">
                        <div className="flex flex-col col-span-5 gap-1 text-start">
                            <p className="font-bold text-base text-gray-900">مبتنی بر بدون نشانگر</p>
                            <p className="font-normal text-sm text-gray-700">بدون استفاده از نشانگر می توانید مدل های سه بعدی خوود بصورت واقعیت افزوده در فضای واقعی مشاده کنید.</p>
                            {user && user.payments && user.payments.type == "DAILY" && (
                                <p className="font-normal text-sm text-gray-500">{`پرداخت روزانه ${formatPrice("4000")} تومان`}</p>
                            )}
                        </div>
                        <div className="col-span-2 m-auto">
                            <img className="free-image" width="85px" src={process.env.REACT_APP_ADDRESS + "/icons/ic-marker-less-ar.svg"} alt="marker-less-ar" />
                        </div>
                    </div>
                </button>
                <button disabled className={`border border-1 h-auto rounded-xl ${typeAR == "FACETRACKING" ? "border-gray-400" : "border-gray-300"}`} onClick={() => setTypeAR("FACETRACKING")}>
                    <div className="grid grid-cols-7 m-4 gap-2">
                        <div className="flex flex-col col-span-5 gap-1 text-start">
                            <p className="font-bold text-base text-gray-500">مبتنی بر تشخیص چهره (بزودی)</p>
                            <p className="font-normal text-sm text-gray-400">با تشخیص چهره و جایگذاری مدل سه بعدی روی صورت می توانید واقعیت افزوده های متمایز ایجاد کنید.</p>
                        </div>
                        <div className="col-span-2 m-auto">
                            <img className="free-image opacity-50" width="85px" src={process.env.REACT_APP_ADDRESS + "/icons/ic-facetracking-ar.svg"} alt="facetracking-ar" />
                        </div>
                    </div>
                </button>

            </div>
        )
    }

    const handleButtonDisableContinue = () => {
        if (typeAR != "" && name != "") {
            return false
        }
        return true
    }

    return (
        <>
            <Layout />
            <Card>
                {isDataLoad ? (

                    <div className="p-5 mb-24 bg-white rounded-lg shadow-md">
                        <h1 className="font-extrabold text-2xl text-start text-black mt-5">پروژه های "فضای کاری من"</h1>
                        <h4 className="font-normal text-lg text-start text-gray-500 mt-2">
                            این محل کار شماست. در اینجا می توانید پروژه خود را اضافه، ویرایش، سازماندهی و حذف کنید.
                        </h4>

                        <InfiniteScroll
                            className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 lg:grid-cols-4 gap-2 mt-10"
                            pageStart={0}
                            loadMore={() => getAllAugmentedReality(page + 1)}
                            hasMore={hasMore}
                            loader={
                                <div key={0} className="text-center m-auto">
                                    <div role="status">
                                        <svg aria-hidden="true" className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                        </svg>
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            }
                        >
                            {/* <div className="cursor-pointer">
                                        <div className="grid place-content-center w-full h-full aspect-square rounded-lg bg-blue-800 gap-3">
                                            <div className="flex justify-center w-full">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="#ffffff" className="w-[8vw] md:w-[6vw] lg:w-[5vw] xl:w-[3vw]" viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" /></svg>
                                            </div>
                                            <div className="w-full font-extrabold text-[3vw] md:text-[2vw] lg:text-[1.8vw] xl:text-[1.2vw] text-white">
                                                ایجاد پروژه جدید
                                            </div>
                                            <div className="flex justify-center w-full">
                                                <Link to="/billing/data">
                                                    <button className=" font-medium text-sm text-white  bg-red-600 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-blue-300  rounded-lg   sm:w-auto px-5 py-2.5 text-center">ارتقای پنل</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div> */}

                            <a className="cursor-pointer" onClick={() => setShowModal(true)}>
                                <div className="grid place-content-center w-full h-full aspect-square rounded-lg bg-blue-800 gap-3">
                                    <div className="flex justify-center w-full">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="#ffffff" className="w-[8vw] md:w-[6vw] lg:w-[5vw] xl:w-[3vw]" viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" /></svg>
                                    </div>
                                    <div className="w-full font-extrabold text-[3vw] md:text-[2vw] lg:text-[1.8vw] xl:text-[1.2vw] text-white">
                                        ایجاد پروژه جدید
                                    </div>
                                </div>
                            </a>



                            {data.map((item, index) => {
                                return item.types == "MARKERLESS" ?
                                    (
                                        <div key={index}>
                                            <Link to={`/projects/edit/${item._id}`}>
                                                <div className={`group relative w-full aspect-square rounded-lg bg-white border border-1 border-gray-300 ${item.status === true ? "opacity-100" : "opacity-60"}`}>
                                                    <div className="hidden group-hover:block absolute w-full h-[60%]">
                                                        <p className="grid place-content-center bg-[#26099f4f] rounded-t-lg w-full h-full text-white m-auto font-extrabold text-[3vw] md:text-[2vw] lg:text-[1.8vw] xl:text-[1.2vw]">مشاهده پروژه</p>
                                                    </div>
                                                    <img className="free-image w-full object-cover rounded-t-lg h-[60%]" src={process.env.REACT_APP_ADDRESS + "/panel/markerless-image.jpeg"} />
                                                    <p className="font-bold text-sm md:text-base lg:text-lg xl:text-lg text-start text-gray-800 h-[20%] mt-2 mx-3">
                                                        {item.name}
                                                    </p>
                                                    <div className="flex w-full mt-2 gap-1">
                                                        <p className="font-normal text-sm h-[10%] w-[60%] text-start text-gray-700 m-auto py-2 pr-2">
                                                            {item.glb_model.length} مدل - {item.view} بازدید
                                                        </p>
                                                        <p className={`font-normal text-[11px] h-[10%] w-[40%] text-end m-auto py-2 pl-2 text-gray-500`}>
                                                            بدون نشانگر
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>

                                        </div>
                                    )
                                    :
                                    (
                                        <div key={index}>
                                            <Link to={`/projects/edit/${item._id}`}>
                                                <div className={`group relative w-full aspect-square rounded-lg bg-white border border-1 border-gray-300 ${item.status === true ? "opacity-100" : "opacity-60"}`}>
                                                    <div className="hidden group-hover:block absolute w-full h-[60%]  ">
                                                        <p className="grid place-content-center bg-[#26099f4f] rounded-t-lg w-full h-full text-white m-auto font-extrabold text-[3vw] md:text-[2vw] lg:text-[1.8vw] xl:text-[1.2vw]">مشاهده پروژه</p>
                                                    </div>
                                                    <img className="free-image w-full object-cover rounded-t-lg h-[60%]" src={process.env.REACT_APP_ADDRESS + "/panel/marker-base-image.jpeg"} />
                                                    <p className="font-bold text-sm md:text-base lg:text-lg xl:text-lg text-start text-gray-800 h-[20%] mt-2 mx-3">
                                                        {item.name}
                                                    </p>
                                                    <div className="flex w-full mt-2 gap-1">
                                                        <p className="font-normal text-sm h-[10%] w-[60%] text-start text-gray-700 m-auto py-2 pr-2">
                                                            {item.image.length} نشانگر - {item.view} بازدید
                                                        </p>
                                                        <p className="font-normal text-[11px] h-[10%] w-[40%] text-end m-auto py-2 pl-2 text-gray-500">
                                                            نشانگر
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    )
                            })}
                        </InfiniteScroll>



                        <CustomModal
                            showModal={showModal}
                            setShowModal={setShowModal}
                            title="ایجاد پروژه"
                            html={htmlPopup()}
                            buttons={[
                                <Link key={"add-projects"} className="w-full" onClick={() => setShowModal(false)} to={`/projects/add/${typeAR}?name=${name}`}>
                                    < button
                                        disabled={handleButtonDisableContinue()}
                                        className={`w-full ${handleButtonDisableContinue() ? "bg-gray-100 text-gray-700 font-normal" : "bg-emerald-500 hover:shadow-lg text-white active:bg-emerald-600 font-bold"}    uppercase text-lg px-6 py-3 rounded shadow  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150`}
                                        type="button"
                                    >
                                        ایجاد واقعیت افزوده
                                    </button >
                                </Link>
                            ]}
                        />

                    </div>
                ) : (
                    <PageChange />
                )}

            </Card>
        </>
    )
}

export default IndexPage